'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2016/8/28.
                    */

// import ReactDOM from 'react-dom';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PersonalServices = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PersonalServices, _Component);

  function PersonalServices() {
    (0, _classCallCheck3.default)(this, PersonalServices);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PersonalServices).apply(this, arguments));
  }

  (0, _createClass3.default)(PersonalServices, [{
    key: 'render',


    /*
     componentDidUpdate() {
     ReactDOM.findDOMNode(this).scrollIntoView();
     } */

    value: function render() {
      var location = this.props.location;
      // const icont10 = require('./img/icont10.png');
      // const icont11 = require('./img/icont11.png');
      // const icont12 = require('./img/icont12.png');
      // const icont13 = require('./img/icont13.png');
      // const icont14 = require('./img/icont14.png');
      // const icont15 = require('./img/icont15.png');
      // const icont16 = require('./img/icont16.png');

      var headArray = [
      /*
       {
       text: '艺术沙龙',
       url: '/personalcenter/personalservices/artsalon',
       img: icont10,
       }, {
       text: '众筹消息',
       url: '/personalcenter/personalservices/crowdfundingmessage',
       img: icont11,
       }, {
       text: '优惠消息',
       url: '/personalcenter/personalservices/preferentialmessage',
       img: icont12,
       }, {
       text: '百科知识',
       url: '/personalcenter/personalservices/encyclopedicknowledge',
       img: icont13,
       },
       */
      {
        text: '关注艺品',
        url: '/personalcenter/personalservices/attentionartwork',
        img: 'http://tupian.goeasy.cn:9999/yipinwang/per_center/art.png'
      }, {
        text: '关注设计师',
        url: '/personalcenter/personalservices/attentiondesigner',
        img: 'http://tupian.goeasy.cn:9999/yipinwang/per_center/designer.png'
      }, {
        text: '关注店铺',
        url: '/personalcenter/personalservices/attentionshop',
        img: 'http://tupian.goeasy.cn:9999/yipinwang/per_center/shop.png'
      }
      /* , {
       text: '消息设置',
       url: '',
       img: icont16,
       }*/
      ];
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.GoeasyTabBar, { data: headArray, activePath: location.pathname }),
        this.props.children
      );
    }
  }]);
  return PersonalServices;
}(_react.Component), _class.propTypes = {
  children: _react.PropTypes.object,
  location: _react.PropTypes.object
}, _temp);
exports.default = PersonalServices;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PersonalServices/PersonalServices.js
 ** module id = 1524
 ** module chunks = 0
 **/